// Tasteful KLYR brand graphic used to keep sparse pages visually uniform.
export const BrandFlourish = ({ className = "" }) => (
  <div className={`flex flex-col items-center justify-center py-10 select-none ${className}`} aria-hidden>
    <svg width="120" height="44" viewBox="0 0 120 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 30 C 30 10, 50 10, 60 22 C 70 10, 90 10, 112 30"
        stroke="#D4A937" strokeWidth="1.4" strokeLinecap="round" fill="none" opacity="0.8" />
      <path d="M60 6 L63.4 16.2 L74 16.2 L65.4 22.6 L68.8 32.8 L60 26.4 L51.2 32.8 L54.6 22.6 L46 16.2 L56.6 16.2 Z"
        fill="#E5C158" opacity="0.95" />
      <circle cx="16" cy="34" r="1.6" fill="#B8860B" />
      <circle cx="104" cy="34" r="1.6" fill="#B8860B" />
    </svg>
    <div className="mt-3 font-ui text-[10px] uppercase tracking-[0.5em] text-gold-500/70">KLYR</div>
  </div>
);
